import { apolloClient } from "@/plugins/vue-apollo.js";

const createGovernate = (_variables) => {
    // , limit, skip
    let responseFromApi;
    let variables = _variables;
    responseFromApi = apolloClient
        .mutate({
            mutation: require("@/settings/api/mutations/governates/create_governate.graphql"),
            variables: variables,
            update: (store, { data }) => {
                const query = {
                    query: require("@/settings/api/queries/governates/governate_query.graphql"),
                    variables: {
                        input: {
                            limit: 10,
                            skip: 0
                        },
                        filter: {
                            searchKey: ''
                        }
                    }
                };
                let allGovernates = store.readQuery(query);
                allGovernates.getGovernates.governates.unshift(data.createGovernate); //push to top
                store.writeQuery({
                    ...query,
                    data: allGovernates,
                });
            }
        })
        .catch(error => {
            return error;
        });
    return responseFromApi;
};
export { createGovernate };
